var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "action-button-updater" }, [
    _c("div", { staticClass: "tabs" }, [
      _c(
        "div",
        {
          staticClass: "tab-button",
          class: { active: _vm.currentTab === 0 },
          on: {
            click: function ($event) {
              _vm.currentTab = 0
            },
          },
        },
        [
          _c("span", { staticClass: "material-icons" }, [_vm._v(" tune ")]),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [_vm._v("General")]),
        ]
      ),
      _vm._v(" "),
      !_vm.whatsappMode
        ? _c(
            "div",
            {
              staticClass: "tab-button",
              class: { active: _vm.currentTab === 1 },
              on: {
                click: function ($event) {
                  _vm.currentTab = 1
                },
              },
            },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v(" bolt ")]),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [_vm._v("Actions")]),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "general-tab", class: { "d-none": _vm.currentTab !== 0 } },
      [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.buttonTitle"))),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Button title",
                "show-attributes": _vm.showAttributes,
                "show-emoji": _vm.showEmoji,
                "max-character-count": 20,
                "whatsapp-mode": _vm.whatsappMode,
                "allowed-attributes": _vm.allowedAttributes,
              },
              model: {
                value: _vm.clone.title,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "title", $$v)
                },
                expression: "clone.title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("message.buttonType"))),
            ]),
            _vm._v(" "),
            _c(
              "a-select",
              {
                staticClass: "w-100",
                attrs: { value: _vm.clone.type },
                on: { change: _vm.handleButtonTypeChange },
              },
              _vm._l(_vm.getAllowedButtonTypes(), function (buttonType) {
                return _c(
                  "a-select-option",
                  { key: buttonType.type, attrs: { value: buttonType.type } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(buttonType.title) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        ["OPEN_MOMENT", "OPEN_URL"].includes(_vm.clone.type)
          ? _c(
              "div",
              { key: _vm.clone.type, staticClass: "section" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v("Website Address"),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: "Enter URL",
                    "show-attributes": true,
                    "show-emoji": false,
                    "max-character-count": 2048,
                    "whatsapp-mode": _vm.whatsappMode,
                    "allowed-attributes": _vm.allowedAttributes,
                  },
                  model: {
                    value: _vm.clone.payload.url,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "url", $$v)
                    },
                    expression: "clone.payload.url",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.clone.type === "PHONE_CALL"
          ? _c(
              "div",
              { key: _vm.clone.type, staticClass: "section" },
              [
                _c("div", { staticClass: "title" }, [_vm._v("Phone Number")]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: {
                    placeholder: "Enter Phone Number",
                    "show-attributes": true,
                    "show-emoji": false,
                    "max-character-count": 16,
                    "whatsapp-mode": _vm.whatsappMode,
                    "allowed-attributes": _vm.allowedAttributes,
                  },
                  model: {
                    value: _vm.clone.payload.phoneNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "phoneNumber", $$v)
                    },
                    expression: "clone.payload.phoneNumber",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.clone.type === "OPEN_MOMENT"
          ? _c(
              "div",
              { key: _vm.clone.type, staticClass: "section" },
              [
                _c("div", { staticClass: "title" }, [_vm._v("Window Size")]),
                _vm._v(" "),
                _c(
                  "a-select",
                  {
                    staticClass: "w-100",
                    attrs: { value: _vm.clone.payload.windowSize },
                    on: {
                      change: function (type) {
                        return (_vm.clone.payload.windowSize = type)
                      },
                    },
                  },
                  _vm._l(_vm.WindowSizes, function (size) {
                    return _c(
                      "a-select-option",
                      { key: size.type, attrs: { value: size.type } },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(size.title) +
                            "\n                "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.clone.type === "GO_TO_BLOCK"
          ? _c(
              "div",
              { key: _vm.clone.type, staticClass: "section" },
              [
                _c("div", { staticClass: "title" }, [_vm._v("Go to")]),
                _vm._v(" "),
                _c("BlockPicker", {
                  attrs: { flattedDiagram: _vm.flattedDiagram },
                  model: {
                    value: _vm.clone.payload.blockId,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone.payload, "blockId", $$v)
                    },
                    expression: "clone.payload.blockId",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action-tab", class: { "d-none": _vm.currentTab !== 1 } },
      [
        _vm.getSetAttributesActions().length
          ? _c(
              "div",
              {
                staticClass: "single-action",
                class: { active: _vm.setAttributeActionActive },
              },
              [
                _c(
                  "div",
                  { staticClass: "remove-action" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-icon-button md-mini",
                        on: { click: _vm.removeAll },
                      },
                      [_c("md-icon", [_vm._v("delete_outline")])],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "single-action-title",
                    on: {
                      click: function ($event) {
                        _vm.setAttributeActionActive =
                          !_vm.setAttributeActionActive
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons text-primary" }, [
                      _vm._v(" data_object "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v("Set custom attribute")]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "single-action-content" }, [
                  _c("div", { staticClass: "set-attributes" }, [
                    _c(
                      "div",
                      { staticClass: "attributes-set" },
                      [
                        _vm._l(
                          _vm.getSetAttributesActions(),
                          function (action, i) {
                            return _c("AttributeSetUpdater", {
                              key: action.id,
                              attrs: {
                                "show-remove-button": true,
                                "on-removed": function () {
                                  return _vm.removeAction(action.id)
                                },
                              },
                              model: {
                                value:
                                  _vm.clone.actions[
                                    _vm.findActionIndex(action.id)
                                  ].payload,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.clone.actions[
                                      _vm.findActionIndex(action.id)
                                    ],
                                    "payload",
                                    $$v
                                  )
                                },
                                expression:
                                  "clone.actions[findActionIndex(action.id)].payload",
                              },
                            })
                          }
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "attributes-set-add" }, [
                          _c(
                            "div",
                            { staticClass: "attributes-set-add-wrapper" },
                            [
                              _c("div", {
                                staticClass: "attributes-set-add-line",
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "attributes-set-add-button",
                                  on: {
                                    click: _vm.addSetCustomAttributeAction,
                                  },
                                },
                                [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "attributes-set-add-text" },
                                    [_vm._v("Add attribute")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.clone.actions.length
          ? _c(
              "div",
              {
                staticClass: "add-single-action",
                on: { click: _vm.addSetCustomAttributeAction },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" add "),
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(" Add new action ")]),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "md-raised md-primary d-block w-100",
            attrs: { disabled: !_vm.saveEnabled() },
            on: { click: _vm.save },
          },
          [_vm._v("Save Settings\n        ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "attributes-set-add-plus" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }